// extracted by mini-css-extract-plugin
export default {"block":"Projects_block__FFBHw","title":"Projects_title__1kvQG","cards":"Projects_cards__LHzIL","cardBlock":"Projects_cardBlock__3MqKP","text":"Projects_text__169w+"};